import React, {useEffect, useState} from "react";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import Grid from "../../../components/Grid";
import {Card} from "reactstrap";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {backupHostOccupancyDefs} from "../../../utils/gridColumnDefs/backups/backupHostOccupancyDefs";
// import {useNavigate} from "react-router-dom";

export default function BackupHostOccupancy({title}) {
    useTitleFromComponent(title);

    const { theme, client, periodId } = useVsiAppContext();
    const [gridData, setGridData] = useState([]);
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/backup_host_occupancy_proc?client_id=${client.clientId}&period_id=${periodId}`);

    useEffect(() => {
        if (data?.recordsets?.[0]?.length) {
            setGridData(data.recordsets[0])
        }
    }, [data]);

    // let navigate = useNavigate();
    // const onRowDoubleClick = (e) => {
    //     navigate(`/reports/database/server/backup-host-detail?instance_name=${encodeURI(e.data.instance_name)}&device_type=${encodeURI(e.data.device_type_code)}`)
    // }

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Backup Host Occupancy</VsiH4>
            <VsiBubble>
                <Grid addStyle
                      gridText={'Double click a server to see more details'}
                      data={gridData}
                      isLoading={isLoading}
                      // rowDoubleClicked={onRowDoubleClick}
                      columnDefs={backupHostOccupancyDefs}/>
            </VsiBubble>
        </Card>
    );
}
